import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  loginLoader: false,
};

export default function logInReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOGIN_INIT_ACTION:
      return {
        ...state,
        loginLoader: true,
      };
    case actionTypes.FETCH_LOGIN_FAIL_ACTION:
      return {
        ...state,
        loginLoader: false,
      };
    case actionTypes.FETCH_LOGIN_SUCCESS_ACTION:
      return {
        ...state,
        loginLoader: false,
      };

    default:
      return {
        ...state,
      };
  }
}
